module.exports = __webpack_public_path__ + "static/media/chatLoader.c356effe.gif";